import { observer } from 'mobx-react';
import React from 'react';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { range } from '@udemy/shared-utils';
import { AcademiesNavItemType } from '../../../events';
import { LEARN_AI_WITH_GOOGLE_NAV_RELATED_ID } from '../../../events';
import { useHeaderStore } from '../../../hooks/use-header-store';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';
export const MobileGoogleCertificateNav = observer(() => {
  const {
    gettext
  } = useI18n();
  const headerStore = useHeaderStore();

  /**
   * Handles click events for L2 nav items (individual Google learning paths).
   * Fires a BrowseNavigationItemSelected event with career_academy type.
   */
  function handleGoogleCertificateNavItemClick(item) {
    const context = {
      id: item.id.toString(),
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      type: AcademiesNavItemType.CAREER_ACADEMY,
      uiRegion: 'main_nav',
      relatedEntityType: AcademiesNavItemType.CAREER_ACADEMY,
      relatedEntityId: LEARN_AI_WITH_GOOGLE_NAV_RELATED_ID
    };
    Tracker.publishEvent(new BrowseNavigationItemSelected(context));
  }
  function renderGoogleCertificateNavItem(item) {
    return /*#__PURE__*/React.createElement(MobileNavItem, {
      onClick: () => handleGoogleCertificateNavItemClick(item),
      key: `mobile-nav-google-certificate-${item.slug}`,
      href: item.absolute_url
    }, item.title);
  }
  function renderGoogleCertificateNavItemList(items) {
    return items && items.length ? items.map(item => renderGoogleCertificateNavItem(item)) : range(4).map(i => /*#__PURE__*/React.createElement(MobileNavItem, {
      key: `google-certificate-id-${i}`,
      loading: true
    }));
  }
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-google-certificates",
    title: gettext('Learn AI with Google'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      size: "small",
      glyph: "google",
      label: ""
    })
  }, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, gettext('Google Learning Paths')), /*#__PURE__*/React.createElement(MobileNavSection, null, renderGoogleCertificateNavItemList(headerStore.userSpecificContext.gwgAcceleratorsNav)));
});
//# sourceMappingURL=mobile-google-certificate-nav.react-component.js.map